export default __webpack_public_path__ + "static/media/data-update-status.40f146a3.svg";